import Layout from "@/views/layout";

const routesMap = [
  {
    path: "",
    component: Layout,
    children: [
      {
        path: "/warehouseReceipt/inbound/import",
        name: "warehouseReceiptInboundImport",
        component: () => import("@/views/warehouse_receipt/OrderImport"),
        props: { kind: "inbound" },
        meta: { permissionRoute: "warehouseReceiptInbound", permissionAction: "create" },
      },
      {
        path: "/warehouseReceipt/outbound/import",
        name: "warehouseReceiptOutboundImport",
        component: () => import("@/views/warehouse_receipt/OrderImport"),
        props: { kind: "outbound" },
        meta: { permissionRoute: "warehouseReceiptOutbound", permissionAction: "create" },
      },
      {
        path: "/warehouseReceipt/inbound",
        name: "warehouseReceiptInbound",
        component: () => import("@/views/warehouse_receipt/InboundOrders"),
      },
      {
        path: "/warehouseReceipt/outbound",
        name: "warehouseReceiptOutbound",
        component: () => import("@/views/warehouse_receipt/OutboundOrders"),
      },
      {
        path: "/warehouseReceipt/accountBook",
        name: "warehouseReceiptAccountBookStock",
        component: () => import("@/views/warehouse_receipt/WarehouseReceiptStock"),
        props: { kind: "accountBook" },
      },
      {
        path: "/warehouseReceipt/expiry",
        name: "warehouseReceiptExpiryStock",
        component: () => import("@/views/warehouse_receipt/WarehouseReceiptStock"),
        props: { kind: "expiry" },
      },
      {
        path: "/warehouseReceipt/operations",
        name: "warehouseReceiptOperation",
        component: () => import("@/views/warehouse_receipt/WarehouseReceiptOperations"),
      },
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/home"),
      },
      {
        name: "order",
        path: "/declareList",
        component: () => import("@/views/declare"),
      },
      {
        name: "declareDetail",
        path: "/declareDetail/:id",
        component: () => import("@/views/declare/DeclareDetail"),
      },
      {
        name: "declareOrderList",
        path: "/declareOrderList",
        component: () => import("@/views/customs_declare"),
      },
      {
        name: "customsDeclareDetail",
        path: "/customsDeclareDetail/:id",
        component: () => import("@/views/customs_declare/CustomsDeclareDetail"),
      },
      {
        name: "declareOrderImport",
        path: "/declareOrderImport",
        component: () => import("@/views/customs_declare/CustomsDeclareImport"),
      },
      {
        name: "purchaseOrder",
        path: "/purchaseOrder",
        component: () =>
          import("@/views/purchase/purchase_order/PurchaseOrder"),
      },
      {
        name: "purchaseOrderDetail",
        path: "/purchaseOrder/:purchaseId",
        component: () =>
          import("@/views/purchase/purchase_order/PurchaseOrderDetail"),
      },
      {
        name: "purchaseOrderImport",
        path: "/purchaseOrderImport",
        component: () =>
          import("@/views/purchase/purchase_order/PurchaseOrderImport"),
      },
      {
        name: "purchaseHeZhuOrder",
        path: "/heZhuOrder/:purchaseId",
        component: () => import("@/views/purchase/hezhu_order/HeZhuOrder"),
      },
      {
        name: "heZhuOrder",
        path: "/heZhuOrder",
        component: () => import("@/views/purchase/hezhu_order/HeZhuOrder"),
      },
      {
        name: "heZhuOrderDetail",
        path: "/heZhuOrderDetail/:heZhuOrderId",
        component: () =>
          import("@/views/purchase/hezhu_order/HeZhuOrderDetail"),
      },
      {
        name: "heZhuOrderImport",
        path: "/heZhuOrderImport/:purchaseId",
        component: () =>
          import("@/views/purchase/hezhu_order/HeZhuOrderImport"),
      },
      {
        name: "taxCommerceAccountList",
        path: "/taxCommerceAccountList",
        component: () =>
          import("@/views/taxes_commerce/TaxesCommerceAccountList.vue"),
      },
      {
        name: "taxesCommerceRechargeDetailList",
        path: "/taxesCommerceRechargeDetailList",
        component: () =>
          import("@/views/taxes_commerce/TaxesCommerceRechargeDetailList.vue"),
      },
      {
        name: "taxesCommerceExpenseCalendarList",
        path: "/taxesCommerceExpenseCalendarList",
        component: () =>
          import("@/views/taxes_commerce/TaxesCommerceExpenseCalendarList.vue"),
      },
      {
        path: "/stockControl",
        name: "stockControl",
        component: () => import("@/views/stockControl"),
      },
      {
        path: "/customerStockList",
        name: "customerStockList",
        component: () => import("@/views/customer_stock"),
      },
      {
        path: "/customerStockAccountList",
        name: "customerStockAccountList",
        component: () =>
          import("@/views/customer_stock/CustomerStockAccountList.vue"),
      },
      {
        path: "/carrierList",
        name: "carrierList",
        component: () => import("@/views/carrier"),
      },
      {
        path: "/roleView",
        name: "role",
        component: () => import("@/views/role"),
      },
      {
        path: "/user_list",
        name: "user",
        component: () => import("@/views/oms_user"),
      },
      {
        path: "/change_password",
        name: "changePassword",
        component: () => import("@/views/change_password"),
      },
      {
        path: "/downloadList",
        name: "download",
        component: () => import("@/views/download"),
      },
      {
        path: "/exceptionTask",
        name: "exceptionTask",
        component: () => import("@/views/exception"),
      },
      {
        path: "/channelView",
        name: "channelView",
        component: () => import("@/views/channel"),
      },
      {
        path: "/merchantView",
        name: "merchantView",
        component: () => import("@/views/merchant"),
      },
      {
        path: "/shopAuthView",
        name: "shopAuthView",
        component: () => import("@/views/shop_authorize"),
      },
      {
        path: "/declareEnterpriseView",
        name: "declareEnterpriseView",
        component: () => import("@/views/declare_enterprise"),
      },
      {
        path: "/channelEcommercePlatformView",
        name: "channelEcommercePlatformView",
        component: () => import("@/views/channel_ecommerce_platform"),
      },
      {
        path: "/enterpriseAccountBookView",
        name: "enterpriseAccountBookView",
        component: () => import("@/views/enterprise_account_book"),
      },
      {
        path: "/nuclearNoteView",
        name: "nuclearNoteView",
        component: () => import("@/views/NuclearNote"),
      },
      {
        path: "/goodsReturnManage",
        name: "goodsReturnManage",
        component: () => import("@/views/goods_return_manage"),
      },
      {
        path: "/returnQualityInspectionWorkbench",
        name: "returnQualityInspectionWorkbench",
        component: () =>
          import(
            "@/views/return_quality_inspection/ReturnQualityInspectionWorkbench"
          ),
      },
      {
        path: "/returnQualityInspectionRecords",
        name: "returnQualityInspectionRecords",
        component: () =>
          import(
            "@/views/return_quality_inspection/ReturnQualityInspectionRecords"
          ),
      },
      {
        path: "/returnDeclareOrderManage",
        name: "returnDeclareOrderManage",
        component: () =>
          import("@/views/goods_return_manage/ReturnDeclareOrderManage"),
      },
      {
        path: "/returnDeclareOrder/heZhu/:returnDeclareOrderId",
        name: "returnDeclareOrderHeZhuOrder",
        component: () => import("@/views/goods_return_manage/HeZhuList"),
      },
      {
        path: "/returnDeclareOrder/heZhuDetail/:heZhuOrderId",
        name: "returnDeclareOrderHeZhuOrderDetail",
        component: () =>
          import("@/views/purchase/hezhu_order/HeZhuOrderDetail"),
      },
      {
        path: "/goodsReturnDetail/:id",
        name: "goodsReturnDetail",
        component: () => import("@/views/goods_return_detail"),
      },
      {
        path: "/checkListManage",
        name: "checkListManage",
        component: () => import("@/views/check_list_manage"),
      },
      {
        path: "/checkListDetail/:id",
        name: "checkListDetail",
        component: () => import("@/views/check_list_detail"),
      },
      {
        path: "/booksManage",
        name: "booksManage",
        component: () => import("@/views/books_manage"),
      },
      {
        path: "/booksManageImport",
        name: "booksManageImport",
        component: () => import("@/views/books_manage_import"),
      },
      {
        path: "/stockAdjustRecord",
        name: "stockAdjustRecord",
        component: () => import("@/views/books_manage/BooksStockAdjustManage"),
      },
      {
        path: "/goodsRecordManage",
        name: "goodsRecordManage",
        component: () => import("@/views/goods_record_manage"),
      },
      {
        name: "goodsDeclareImport",
        path: "/goodsDeclareImport",
        component: () =>
          import("@/views/goods_record_manage/GoodsRecordImport"),
      },
      {
        path: "/nuclearNoteManage",
        name: "nuclearNoteManage",
        component: () => import("@/views/nuclear_note_manage"),
      },
      {
        path: "/cancelLationsManage",
        name: "cancelLationsManage",
        component: () => import("@/views/cancel_lations_manage"),
      },
      {
        path: "/orderActionRecord",
        name: "orderActionRecord",
        component: () => import("@/views/order_action_record"),
      },
      {
        path: "/importPreview",
        name: "importPreview",
        component: () => import("@/views/import_preview"),
      },
      {
        path: "/orderErrorList",
        name: "orderErrorList",
        component: () => import("@/views/order/order_error"),
      },
      {
        path: "/customer/declareOrderList",
        name: "customerDeclareOrderList",
        component: () => import("@/views/customer/DeclareOrderList"),
      },
      {
        path: "/customer/declareOrderDetail/:id",
        name: "customerDeclareOrderDetail",
        component: () => import("@/views/customer/DeclareOrderDetail"),
      },
      {
        path: "/customer/taxAccountList",
        name: "taxAccountList",
        component: () => import("@/views/customer/TaxAccountList"),
      },
      {
        path: "/b2b",
        name: "b2b",
        component: () => import("@/views/b2b"),
      },
      {
        path: "/b2b/create",
        name: "b2bCreate",
        component: () => import("@/views/b2b/B2BCreateOrUpdate"),
      },
      {
        path: "/b2b/heZhu/:toBStockoutOrderId",
        name: "b2bHeZhuOrder",
        component: () => import("@/views/b2b/HeZhuList"),
      },
      {
        path: "/b2b/heZhuDetail/:heZhuOrderId",
        name: "b2bHeZhuOrderDetail",
        component: () =>
          import("@/views/purchase/hezhu_order/HeZhuOrderDetail"),
      },
      {
        path: "/douYin/traceLog",
        name: "douYinTraceLog",
        component: () => import("@/views/douyin/TraceLog"),
      },
      {
        path: "/customer/list",
        name: "customer",
        component: () => import("@/views/customer/CustomerList"),
      },
      {
        path: "/douYinWarehouseFeeOrder/list",
        name: "douYinWarehouseFeeOrder",
        component: () => import("@/views/douyin/WarehouseFeeOrder"),
      },
      {
        path: "/ecommerceHeZhu/list",
        name: "ecommerceHeZhu",
        component: () => import("@/views/ecommerce_he_zhu/ECommerceHeZhu"),
      },
      {
        path: "/eCommerceHeZhuDetail/:id",
        name: "eCommerceHeZhuDetail",
        component: () =>
          import("@/views/ecommerce_he_zhu/ECommerceHeZhuDetail"),
      },
      {
        path: "/orderNotifyConfig/list",
        name: "orderNotifyConfig",
        component: () => import("@/views/order_notify_config"),
      },
      {
        path: "/customer/purchaseList",
        name: "customerPurchaseList",
        component: () => import("@/views/customer/PurchaseList"),
      },
      {
        path: "/customer/toBOrderList",
        name: "customerToBOrderList",
        component: () => import("@/views/customer/ToBOrderList"),
      },
      {
        path: "/itemNoMapping",
        name: "itemNoMapping",
        component: () => import("@/views/item_no_mapping"),
      },
      {
        path: "/dataExport",
        name: "dataExport",
        component: () => import("@/views/data_export"),
      },
    ],
  },
];

export default routesMap;
